// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2sSao","label":"LabeledBox_label__eu_j5"};